import { css, cva } from "@styled-system/css";
import { stack } from "@styled-system/patterns";

export const wrapperClass = css({
	position: "relative",
});

export const labelClass = cva({
	base: {
		display: "block",
		mb: "4",
	},
	variants: {
		success: {
			true: {
				color: "success.100",
			},
		},
		error: {
			true: {
				color: "error.100",
			},
		},
		disabled: {
			true: {
				color: "shade.20",
			},
		},
	},
});
export const smallTextBelowClass = cva({
	base: {
		display: "block",
		mt: "4",
	},
	variants: {
		success: {
			true: {
				color: "success.100",
			},
		},
		error: {
			true: {
				color: "error.100",
			},
		},
		disabled: {
			true: {
				color: "shade.20",
			},
		},
	},
});

export const growDivClass = css({
	width: "full",
});

export const iconClass = cva({
	base: {
		position: "absolute",
		transform: "translateY(30%)",
		pl: "8",
	},
	variants: {
		error: {
			true: {
				color: "error.100!",
			},
		},
		success: {
			true: {
				color: "success.100!",
			},
		},
	},
});

export const inputTextClass = cva({
	base: {
		textStyle: "p2!",
		width: "full!",
		color: "shade.100!",
		border: "1px solid!",
		borderColor: "shade.40!",
		borderRadius: "4",
		_hover: {
			borderColor: "shade.40!",
			color: "shade.100!",
		},
		_focus: {
			borderColor: "info.100!",
			boxShadow: "[none!]",
		},
		_placeholder: {
			color: "shade.20!",
		},
		_disabled: {
			borderColor: "shade.5!",
			border: "6px solid!",
			borderStyle: "none!",
			color: "shade.60!",
			backgroundColor: "shade.5!",
		},
	},
	variants: {
		error: {
			true: {
				borderColor: "error.100!",
				border: "1px solid!",
				_hover: {
					borderColor: "error.100!",
				},
				_focus: {
					borderColor: "error.100!",
				},
			},
		},
		success: {
			true: {
				borderColor: "success.100!",
				border: "1px solid!",
				_hover: {
					borderColor: "success.100!",
				},
				_focus: {
					borderColor: "success.100!",
				},
			},
		},
		hasIcon: {
			true: { pl: "40!" },
		},
	},
});

export const suggestionsWrapperClass = stack({
	overflowY: "hidden",
	mt: "4",
});
